"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var locales = {};

["en", "de", "fr", "es", "pt", "pl", "ja", "zh", "el", "it", "ro", "ru", "uk"].forEach(function (lng) {
  // eslint-disable-next-line
  _extends(locales, require("./" + lng + ".yml"));
});

exports.default = locales;